export const stringify = (input, opts = {}) => {
  const delim = opts.delim || ',';
  const quote = opts.quote || '"';
  const eol = opts.eol || '\n';
  
  const headers = input.headers.map(header => {
    if (typeof header === 'string') {
      return { title: header, key: header };
    }
    return header;
  });

  // const data = input.data.map(item => {
  //   if (!Array.isArray(item)) {
  //     item = headers.map(({ key }) => item[key] || '');
  //   }
  //   return item;
  // });

  const columns = headers
    .map(header => {
      let col = '';
      if (typeof header === 'object') {
        col = header.title;
      } else {
        col = header.toString();
      }
      return `${quote}${col}${quote}`
    })
    .join(delim);

  const rows = input.data.map((item, index) => {
    return headers.map((header) => {
      let value = '';

      if (typeof header.key === 'string') {
        value = item[header.key];
      } else if (typeof header.getValue === 'function') {
        value = header.getValue(item, index);
      }

      if (typeof value === 'number') {
        return value;
      } else {
        return quote + value + quote;
      }
    }).join(delim);
  }).join(eol);

  return [columns, rows].join(eol);
};
